<template>
<div>
  <v-layout row wrap justify-center>
    <v-flex class="text-xs-center pt-2" xs12 md11>
      <div class="headline text-xs-center"><b>{{loading ? 'Loading' : taskData.name}}</b></div>
      <v-divider class="my-3"></v-divider>
    </v-flex>
  </v-layout>
  <v-layout v-if="loading" row justify-center>
    <v-flex class="text-xs-center py-5 my-5" xs12>
      <div class="py-5 my-5">
        <v-progress-circular color="accent" indeterminate></v-progress-circular>
      </div>
    </v-flex>
  </v-layout>
  <v-layout v-else-if="status == 'START'" row wrap justify-center>
    <v-flex class="pt-1 text-xs-center" xs12>
      <div class="subheading text-xs-center">
        <span>Attempts: <b>{{taskData.attempts ? taskData.attempts : 'Unlimited'}}</b></span>
        <span class="grey--text text--lighten-3">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
        <span>Time: <b>{{taskData.timeAllowed ? taskData.timeAllowed + ' mins' : 'Unlimited'}}</b></span>
      </div>
      <div v-if="test" class="my-3 text-xs-center">
        <v-btn @click.native="startable" class="title" color="success">Continue</v-btn>
        <div class="question-body secondary--text pt-1">
          <v-icon class="mb-2" color="secondary">alarm</v-icon>
          <b>{{taskData.timeAllowed ? timeLeftString : 'Unlimited Time'}}</b>
        </div>
      </div>
      <div v-else class="my-3 text-xs-center">
        <div v-if="taskData.attempts">
          <div v-if="testAttempts.length >= parseInt(taskData.attempts)" class="error--text"><b>No Attempts Left</b></div>
        </div>
        <v-btn @click.native="startable" class="title" color="success">Start</v-btn>
      </div>
      <div class="title mb-2 mt-4 text-xs-center"><b>Previous Attempts</b></div>
      <div v-if="testAttempts.length == 0" class="my-5 display-1 grey--text text--lighten-2">None</div>
      <v-layout v-else class="px-2 pb-3" row wrap justify-center>
        <template v-for="(attempt, i) in testAttempts">
          <v-flex :key="`attempt-${i}`" class="text-xs-left" xs1>{{testAttempts.length - i}}</v-flex>
          <v-flex :key="`attempttime-${i}`" class="text-xs-left" xs10 md8>{{(new Date(attempt.startTime)).toLocaleString()}}</v-flex>
          <v-flex :key="`attemptbody-${i}`" class="text-xs-right" xs1>
            <span
              v-if="now < attempt.endTime"
              class="grey--text"
            ><b>--%</b></span>
            <span
              v-else-if="attempt.grade >= 60"
              class="success--text"
            ><b>{{attempt.grade + '%'}}</b></span>
            <span
              v-else-if="attempt.grade >= 55"
              class="accent--text"
            ><b>{{attempt.grade + '%'}}</b></span>
            <span
              v-else
              class="error--text"
            ><b>{{attempt.grade + '%'}}</b></span>
          </v-flex>
          <v-flex :key="`divider-${i}`" v-if="i != (testAttempts.length - 1)" xs12 md10><v-divider class="my-1"></v-divider></v-flex>
          <v-flex :key="`linebreak-${i}`" xs12></v-flex>
        </template>
      </v-layout>
    </v-flex>
  </v-layout>
  <v-layout v-else-if="status == 'IN PROGRESS' && test" row wrap justify-center>
    <v-flex class="pt-1 text-xs-center" xs8 sm5 md4>
      <div class="headline pa-2 secondary--text">
        <v-icon class="mb-2" color="secondary" medium>alarm</v-icon>
        <b>{{taskData.timeAllowed ? timeLeftString : 'Unlimited Time'}}</b>
      </div>
    </v-flex>
    <v-flex xs12>
      <div class="question-body pa-2"><b>Question #{{test.currentQuestion + 1}}</b></div>
      <div @keydown="disableCopy($event)" tabindex="0" class="question-body pa-2 mb-2">{{questionData.body}}</div>
    </v-flex>
    <v-flex class="text-xs-center" xs12>
      <v-card
        @click.native="!test.graded ? chooseAnswer(i) : ''"
        @mouseover="!test.graded ? answer.hover = true : ''"
        @mouseout="!test.graded ? answer.hover = false : ''"
        style="cursor: pointer"
        v-for="(answer, i) in questionData.answers"
        :key="i"
        class="pa-2 mb-2"
        :color="(test.graded && answer.correct && answer.selected) ? 'success' : (test.graded && !answer.correct && answer.selected) ? 'error' : answer.selected ? 'grey lighten-2 elevation-1' : answer.hover ? 'grey lighten-4 elevation-0' : 'elevation-0'">
        <v-layout row wrap>
          <v-flex class="pr-2" xs1>
            <div class="question-body pt-1">{{answer.letter}}.</div>
          </v-flex>
          <v-flex class="pl-2 text-xs-left" xs11>
            <div @keydown="disableCopy($event)" tabindex="1" class="question-body pt-1">{{answer.text}}</div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <!-- WITH RATIONALE -->
    <!-- <v-flex v-if="test.graded" class="pb-3 text-xs-center" xs12>
      <div class="headline pb-3">
        <span v-if="test.correct" class="success--text caps"><b>Correct</b></span>
        <span v-else class="error--text caps"><b>Wrong</b></span>
      </div>
      <div class="question-body text-xs-left">
        <span><b>Rationale</b></span><br>
        <span>{{questionData.rationale}}</span>
      </div>
    </v-flex>
    <v-flex class="pb-3 text-xs-center" xs12>
      <v-btn v-if="!test.graded" @click.native="gradeTest" class="title" color="primary" large><b>Check</b></v-btn>
      <v-btn v-else @click.native="nextQuestion" class="title" color="success" large><b>Next</b></v-btn>
    </v-flex> -->
    <!-- WITHOUT RATIONALE -->
    <v-flex class="pb-3 text-xs-center" xs12>
      <v-btn @click.native="gradeTest" class="title" color="success" large><b>Next</b></v-btn>
    </v-flex>
  </v-layout>
  <v-layout v-else-if="status == 'FINISHED'" row wrap justify-center>
    <v-flex class="pt-4 pb-5 mb-3 text-xs-center" xs12>
      <div class="headline">
        <span>Attempt {{testAttempts.length}}: </span>
        <span v-if="testAttempts[0].passing" class="success--text"><b>Pass</b></span>
        <span v-else-if="testAttempts[0].failing" class="error--text"><b>Fail</b></span>
        <span v-else-if="testAttempts[0].grade >= passGrade" class="success--text"><b>Pass</b></span>
        <span v-else-if="testAttempts[0].grade >= almostPassGrade" class="accent--text"><b>Near Pass</b></span>
        <span v-else class="error--text"><b>Fail</b></span>
      </div>
      <v-layout class="px-2 py-3" row wrap justify-center>
        <template v-for="(area, i) in Object.keys(testAttempts[0].totals)">
          <v-flex :key="`area-${i}`" class="text-xs-left" xs10 md9>{{area}}</v-flex>
          <v-flex :key="`areabody-${i}`" class="text-xs-right" xs1>
            <span
              v-if="testAttempts[0].grades[area] >= passGrade"
              class="success--text"
            ><b>{{testAttempts[0].grades[area] + '%'}}</b></span>
            <span
              v-else-if="testAttempts[0].grades[area] >= almostPassGrade"
              class="accent--text"
            ><b>{{testAttempts[0].grades[area] + '%'}}</b></span>
            <span
              v-else
              class="error--text"
            ><b>{{testAttempts[0].grades[area] + '%'}}</b></span>
          </v-flex>
          <v-flex :key="`areadivider-${i}`" v-if="i != (Object.keys(testAttempts[0].totals).length - 1)" xs12 md10><v-divider class="my-1"></v-divider></v-flex>
          <v-flex :key="`arealinebreak-${i}`" xs12></v-flex>
        </template>
      </v-layout>
      <v-btn @click.native="leave" class="title mt-4" color="success" large><b>Done</b></v-btn>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    enough: false,
    status: 'START',
    possibleQuestions: [],
    area: [],
    questionData: {},
    currentProgress: null,
    taskData: null,
    timer: null
  }),
  beforeMount () {
    this.load()
  },
  computed: {
    now () {
      return this.$store.getters.now
    },
    test () {
      for (let t of this.$store.getters.taskProgress) {
        if (t.taskKey === this.currentProgress.task && t.progressKey === this.currentProgress.progress && t.endTime) {
          if (t.endTime > this.now) return t
        }
      }
      if (this.status === 'IN PROGRESS') {
        this.status = 'FINISHED'
      }
      return undefined
    },
    testAttempts () {
      return this.$store.getters.testAttempts(this.currentProgress.task, this.currentProgress.progress).reverse()
    },
    timeLeftString () {
      if (this.test) {
        if (this.test.endTime > this.now) {
          const time = new Date(this.test.endTime - this.now)
          let string = ''
          let hrs = time.getUTCHours()
          let mins = time.getUTCMinutes()
          let secs = time.getUTCSeconds()
          let hrString = hrs > 9 ? ('' + hrs) : ('0' + hrs)
          let minString = mins > 9 ? ('' + mins) : ('0' + mins)
          let secString = secs > 9 ? ('' + secs) : ('0' + secs)
          string += hrs > 0 ? (hrString + ':') : ''
          string += minString + ':' + secString
          return string
        } else return 'Ended'
      } else return ''
    },
    passGrade () {
      return this.taskData ? this.taskData.passGrade || 65 : 65
    },
    almostPassGrade () {
      return Math.floor(this.passGrade - (this.passGrade * 0.2))
    }
  },
  methods: {
    load () {
      this.loading = true
      this.currentProgress = this.$store.getters.currentProgress
      this.taskData = this.$store.getters.taskByKey(this.currentProgress.task)
      if (this.taskData.type === 'Linking') this.taskData = this.$store.getters.taskByKey(this.taskData.linkedTaskKey)
      this.getPossibleQuestions()
      this.loading = false
    },
    getPossibleQuestions () {
      const q = this.$store.getters.questions
      let possible = []
      let totals = {}
      this.enough = true
      for (let question of q) {
        if (question.area && question.tags.includes(this.taskData.tags)) {
          possible.push(question.key)
          for (let area of question.area) {
            if (!this.area.includes(area)) this.area.push(area)
            if (!totals[area]) totals[area] = 1
            else totals[area] += 1
          }
        }
      }
      for (let area of Object.keys(totals)) {
        if (totals[area] < parseInt(this.taskData.maxQuestions)) this.enough = false
      }
      this.possibleQuestions = possible
    },
    startable () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (!this.enough) {
        appMsg.msg = 'Fatal error while starting test, please contact the instructor'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.taskData.attempts) {
        let finishedAttempts = 0
        for (const ta of this.testAttempts) if (this.now >= ta.endTime) finishedAttempts += 1
        if (finishedAttempts >= parseInt(this.taskData.attempts)) {
          appMsg.msg = 'You have no more attempts!'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
      }
      // REMOVED until further notice
      // if (this.testAttempts.length > 0) {
      //   if (this.now - this.testAttempts[0].startTime <= this.$store.getters.time.day && this.now >= this.testAttempts[0].endTime) {
      //     appMsg.msg = 'Please spend more time to study before taking another attempt'
      //     this.$store.dispatch('showAppMsg', appMsg)
      //     return
      //   }
      // }
      this.startTest()
    },
    startTest () {
      this.loading = true
      if (this.test) {
        this.loadQuestion()
        this.startTimer()
        this.status = 'IN PROGRESS'
        this.loading = false
      } else {
        const newTaskProgress = {
          taskKey: this.currentProgress.task,
          progressKey: this.currentProgress.progress,
          studentId: this.$store.getters.user.uid,
          startTime: this.now,
          endTime: this.now + (this.$store.getters.time.minute * parseInt(this.taskData.timeAllowed)),
          questions: [],
          currentQuestion: 0,
          graded: false,
          correct: false,
          choice: [],
          currents: {},
          totals: {},
          scores: {},
          grades: {},
          score: 0,
          grade: 0,
          passing: false,
          failing: false
        }
        for (let area of this.area) {
          newTaskProgress.currents[area] = 0
          newTaskProgress.scores[area] = 0
          newTaskProgress.grades[area] = 0
          newTaskProgress.totals[area] = parseInt(this.taskData.minQuestions)
        }
        newTaskProgress.questions = this.getQuestions(newTaskProgress.currents, newTaskProgress.totals)
        this.$store.dispatch('createTaskProgress', newTaskProgress).then(() => {
          this.loadQuestion()
          this.startTimer()
          this.status = 'IN PROGRESS'
          this.loading = false
        }).catch(err => {
          console.log(err.message)
          const appMsg = {
            type: 'error',
            msg: 'Fatal error while creating test. Please refresh page.'
          }
          this.$store.dispatch('showAppMsg', appMsg)
        })
      }
    },
    getQuestions (currents, totals) {
      let random = null
      let q = null
      let questions = this.test ? [...this.test.questions] : []
      let expected = 0
      for (let area of Object.keys(totals)) {
        expected += totals[area]
      }
      while (questions.length < expected) {
        random = this.$store.getters.rng(0, this.possibleQuestions.length - 1)
        q = this.$store.getters.questionByKey(this.possibleQuestions[random])
        if (!questions.includes(q.key)) {
          for (let area of Object.keys(totals)) {
            if (q.area.includes(area) && currents[area] < totals[area]) {
              questions.push(q.key)
              currents[area] += 1
            }
          }
        }
      }
      return questions
    },
    loadQuestion () {
      this.loading = true
      const q = this.$store.getters.questionByKey(this.test.questions[this.test.currentQuestion])
      let qData = {
        ...q,
        questionNum: this.test.currentQuestion,
        correct: false,
        tags: q.tags ? [...q.tags] : [],
        area: q.area ? [...q.area] : [],
        answers: []
      }
      for (let answer of q.answers) {
        qData.answers.push({
          ...answer,
          hover: false,
          selected: false
        })
      }
      this.questionData = qData
      if (this.test.graded && this.test.choice) {
        for (let i of this.test.choice) {
          this.chooseAnswer(i)
        }
      }
      this.loading = false
    },
    gradeTest () {
      this.loading = true
      let newTaskProgress = {
        ...this.test,
        questions: [...this.test.questions],
        choice: [],
        currents: {...this.test.currents},
        grades: {...this.test.grades},
        totals: {...this.test.totals},
        scores: {...this.test.scores},
        correct: true,
        graded: true
      }
      for (let i = 0; i < this.questionData.answers.length; i++) {
        if (this.questionData.answers[i].selected) newTaskProgress.choice.push(i)
        if (this.questionData.answers[i].correct !== this.questionData.answers[i].selected) newTaskProgress.correct = false
      }
      if (newTaskProgress.correct) {
        newTaskProgress.score += 1
        for (let area of this.questionData.area) {
          newTaskProgress.scores[area] += 1
        }
      }
      newTaskProgress.grade = Math.round((newTaskProgress.score / newTaskProgress.questions.length) * 100)
      for (let area of this.questionData.area) {
        newTaskProgress.grades[area] = Math.round((newTaskProgress.scores[area] / newTaskProgress.totals[area]) * 100)
      }
      let pass = 0
      let fail = 0
      for (let area of Object.keys(newTaskProgress.totals)) {
        if (newTaskProgress.grades[area] >= this.passGrade) pass += 1
        else if (newTaskProgress.grades[area] < this.almostPassGrade) fail += 1
      }
      if (pass >= 6) newTaskProgress.passing = true
      else if (fail >= 6) newTaskProgress.failing = true
      this.$store.dispatch('updateTaskProgress', newTaskProgress).then(() => {
        this.nextQuestion()
      }).catch(err => {
        console.log(err.message)
        const appMsg = {
          type: 'error',
          msg: 'Fatal error while grading question. Please refresh page.'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      })
    },
    nextQuestion () {
      // this.loading = true
      let next = false
      let newTaskProgress = {
        ...this.test,
        questions: [...this.test.questions],
        choice: [],
        currents: {...this.test.currents},
        grades: {...this.test.grades},
        totals: {...this.test.totals},
        scores: {...this.test.scores},
        graded: false
      }
      if (this.test.currentQuestion < (this.test.questions.length - 1)) {
        newTaskProgress.currentQuestion = this.test.currentQuestion + 1
        next = true
      } else {
        if (newTaskProgress.passing || newTaskProgress.failing) {
          this.endTest()
          return
        } else {
          let increased = false
          for (let area of Object.keys(newTaskProgress.totals)) {
            if (newTaskProgress.grades[area] < this.passGrade && newTaskProgress.totals[area] < parseInt(this.taskData.maxQuestions)) {
              newTaskProgress.totals[area] += 1
              increased = true
            }
          }
          if (increased) {
            newTaskProgress.questions = this.getQuestions(newTaskProgress.currents, newTaskProgress.totals)
            next = true
          }
        }
      }
      if (next) {
        this.$store.dispatch('updateTaskProgress', newTaskProgress).then(() => {
          this.$store.dispatch('getTime').then(now => {
            this.$store.commit('setNow', now)
            this.loadQuestion()
            this.loading = false
          }).catch(err => {
            const appMsg = {
              type: 'error',
              msg: 'Fatal error while changing questions. Please refresh the page.'
            }
            console.log(err)
            this.$store.dispatch('showAppMsg', appMsg)
          })
        }).catch(err => {
          const appMsg = {
            type: 'error',
            msg: 'Fatal error while changing questions. Please refresh the page.'
          }
          console.log(err)
          this.$store.dispatch('showAppMsg', appMsg)
        })
      } else this.endTest()
    },
    endTest () {
      this.loading = true
      let newTaskProgress = {
        ...this.test,
        questions: [...this.test.questions],
        endTime: this.now,
        currents: {...this.test.currents},
        grades: {...this.test.grades},
        totals: {...this.test.totals},
        scores: {...this.test.scores}
      }
      this.$store.dispatch('updateTaskProgress', newTaskProgress).then(() => {
        this.stopTimer()
        this.status = 'FINISHED'
        this.loading = false
      }).catch(err => {
        console.log(err.message)
        const appMsg = {
          type: 'error',
          msg: 'Fatal error while submitting test. Please refresh the page.'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      })
    },
    chooseAnswer (index) {
      if (this.questionData.type === 'Select All That Apply') {
        for (let i = 0; i < this.questionData.answers.length; i++) {
          if (i === index) this.questionData.answers[i].selected = !this.questionData.answers[i].selected
        }
      } else {
        for (let i = 0; i < this.questionData.answers.length; i++) {
          if (i === index) this.questionData.answers[i].selected = true
          else this.questionData.answers[i].selected = false
        }
      }
    },
    startTimer () {
      this.timer = setInterval(() => {
        if (this.test && this.status !== 'START') {
          if (this.now > this.test.endTime) {
            this.endTest()
          }
          if (this.questionData.questionNum !== this.test.currentQuestion) this.loadQuestion()
        }
      }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    leave () {
      let currentProgress = this.$store.getters.currentProgress
      this.$store.dispatch('setCurrentProgress', {
        progress: currentProgress.progress,
        section: currentProgress.section,
        task: null
      })
      this.$router.push('/my-courses/course-view/my-tasks')
    },
    disableCopy (event) {
      if (event.key === 'c' && event.ctrlKey) event.preventDefault()
    }
  }
}
</script>

<style>
.question-body {
  font-size: 20px;
  line-height: 150%;
}
.question-body:focus {
  outline: none;
}
.score-text {
  font-size: 170px;
  line-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/myCourses/NclexTask.vue